export class DiscountModel {
  public name: string;

  constructor(params: DiscountModel) {
    this.name = params.name;
  }

  public static fromCartV1(name: string) {
    return new DiscountModel({name});
  }
}
